import React from 'react';
import { Route, Switch } from 'react-router-dom';

import CollectionSettings from '../../../Settings/CollectionSettings/index';
import CollectionCreateUpdate from '../../../Settings/CollectionSettings/Collection';

import Inference from '../../../Inference/index';
import InferenceCreateUpdate from '../../../Inference/InferenceCreateUpdate';

import AssetManagement from '../../../Settings/AssetManagement/index';
import AssetsManagementCreateUpdate from '../../../Settings/AssetManagement/Assets';
import ImportAssets from '../../../Settings/AssetManagement/components/ImportAssets';
import ImportComponents from '../../../Settings/AssetManagement/components/ComponentList/ImportComponents';
import ComponentsCreateUpdate from '../../../Settings/AssetManagement/components/ComponentsCreateUpdate';
import ProcessManagement from '../../../Settings/ProcessManagement/index';

export default () => (
  <Switch>
    <Route path="/settings/collection_settings" component={CollectionSettings} />
    <Route path="/settings/create_update_collection" component={CollectionCreateUpdate} />
    <Route path="/settings/inference" component={Inference} />
    <Route path="/settings/inference/create_update_inference" component={InferenceCreateUpdate} />
    <Route path="/settings/asset_management" component={AssetManagement} />
    <Route path="/settings/create_update_asset_management" component={AssetsManagementCreateUpdate} />
    <Route path="/settings/assets_management/import_assets" component={ImportAssets} />
    <Route path="/settings/assets_management/import_component" component={ImportComponents} />
    <Route path="/settings/assets_management/create_update_component" component={ComponentsCreateUpdate} />
    <Route path="/settings/process_management" component={ProcessManagement} />
  </Switch>
);
